(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sp-pdp-cro-v56-product-premium"] && !Shopify.designMode) return;
  try {
    (() => {
    document.body.classList.add('sp-pdp-premium-v55-page');
    document.body.dataset.spPdpPremiumVersion = '5.6.5';

    const revealComplementaryProducts = (root = document) => {
      root.querySelectorAll('product-recommendations[hidden]').forEach((element) => {
        if (element.querySelector('.complementary-products')) element.hidden = false;
      });
    };

    const syncAccordionState = (root = document) => {
      root.querySelectorAll('.shopify-section--main-product details.accordion__disclosure').forEach((details) => {
        details.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        if (details.dataset.spPremiumBound === 'true') return;
        details.dataset.spPremiumBound = 'true';
        details.addEventListener('toggle', () => {
          details.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        });
      });
    };

    const applyDescriptionPreview = (root = document) => {
      const summaries = [...root.querySelectorAll('.shopify-section--main-product .product-content-below-gallery summary')];
      const summary = summaries.find((element) => {
        return /^(beschreibung|description)$/i.test(element.innerText.trim());
      });
      const details = summary ? summary.closest('details') : null;
      const wrapper = details ? details.parentElement : null;
      const source = details ? details.querySelector('.accordion__content p') : null;

      if (!details || !wrapper || !source) return;

      let preview = wrapper.querySelector(':scope > .sp-description-preview');
      if (!preview) {
        preview = document.createElement('div');
        preview.className = 'sp-description-preview';
        preview.setAttribute('aria-hidden', 'true');

        const paragraph = document.createElement('p');
        paragraph.textContent = source.textContent.trim();
        preview.append(paragraph);
        details.insertAdjacentElement('afterend', preview);

        details.addEventListener('toggle', () => {
          preview.hidden = details.open;
        });
      }

      preview.hidden = details.open;
    };

    const positionOccasionLinks = (root = document) => {
      root.querySelectorAll('.shopify-section--main-product .product-content-below-gallery').forEach((container) => {
        const occasionLinks = container.querySelector('.product-occasion-links');
        const recommendations = container.querySelector(':scope > product-recommendations');
        if (!occasionLinks || !recommendations || recommendations.previousElementSibling === occasionLinks) return;
        recommendations.insertAdjacentElement('beforebegin', occasionLinks);
      });
    };

    const applyPremiumProductPage = () => {
      revealComplementaryProducts();
      syncAccordionState();
      applyDescriptionPreview();
      positionOccasionLinks();
    };

    const focusFirstInvalidPersonalizationField = (event) => {
      const button = event.target.closest('.buy-buttons button[type="submit"], .product-sticky-bar button[type="submit"]');
      if (!button) return;

      const invalidFields = [...document.querySelectorAll('.sp-pdp-cro-v22-customizer input:invalid, .sp-pdp-cro-v22-customizer select:invalid, .sp-pdp-cro-v22-customizer textarea:invalid')];
      const firstInvalid = invalidFields.find((field) => {
        return !field.disabled && field.getClientRects().length > 0;
      });

      if (!firstInvalid) return;

      event.preventDefault();
      firstInvalid.setAttribute('aria-invalid', 'true');
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => firstInvalid.focus({ preventScroll: true }), 250);
    };

    const clearResolvedInvalidState = (event) => {
      const field = event.target.closest('.sp-pdp-cro-v22-customizer [aria-invalid="true"]');
      if (field && field.validity.valid) field.removeAttribute('aria-invalid');
    };

    applyPremiumProductPage();
    document.addEventListener('shopify:section:load', applyPremiumProductPage);

    if (!window.__spPdpPremiumV55ValidationBound) {
      window.__spPdpPremiumV55ValidationBound = true;
      document.addEventListener('click', focusFirstInvalidPersonalizationField, true);
      document.addEventListener('input', clearResolvedInvalidState, true);
      document.addEventListener('change', clearResolvedInvalidState, true);
    }

    if (!window.__spPdpPremiumV55Observer) {
      let queued = false;
      window.__spPdpPremiumV55Observer = new MutationObserver(() => {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(() => {
          queued = false;
          applyPremiumProductPage();
        });
      });
      window.__spPdpPremiumV55Observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
